import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessUnitCompanyInformationModel } from '../business-unit-company-information.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-billing-company-information-view',
    templateUrl: './billing-company-information-view.component.html',
    styleUrls: ['./billing-company-information-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-company-information-view' },
    standalone: false,
})
export class BillingCompanyInformationViewComponent implements OnInit {
    @Input() businessUnitCompanyInformation: BusinessUnitCompanyInformationModel;
    editTabs: EditTabsModel;

    constructor(
        private fiStateService: FiStateService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('billing.company_information'),
            this.appTextService.get('back'),
        );
    }

    editBillingCompanyInformation() {
        this.fiStateService.go(FiStateNames.Billing.CompanyInformation.Edit, {
            BusinessUnitId: this.businessUnitCompanyInformation.BusinessUnitId,
        });
    }
}
